import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { assetsAPI } from '../utils/api';
import { toast } from 'sonner';

export function CreateAssetModal({ open, onClose, onCreated, siteId }) {
  const [form, setForm] = useState({
    asset_name: '',
    installed_power_kw: '',
    installed_capacity_kwh: '',
    manufacturer: '',
    model: '',
    serial_number: '',
    vendor_asset_id: '',
    commissioned_at: '',
  });
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.asset_name || !form.installed_power_kw || !form.installed_capacity_kwh) {
      toast.error('Name, Power, and Capacity are required');
      return;
    }
    setSaving(true);
    try {
      const formData = new FormData();
      formData.append('site_id', siteId);
      formData.append('asset_name', form.asset_name);
      formData.append('installed_power_kw', form.installed_power_kw);
      formData.append('installed_capacity_kwh', form.installed_capacity_kwh);
      if (form.manufacturer) formData.append('manufacturer', form.manufacturer);
      if (form.model) formData.append('model', form.model);
      if (form.serial_number) formData.append('serial_number', form.serial_number);
      if (form.vendor_asset_id) formData.append('vendor_asset_id', form.vendor_asset_id);
      if (form.commissioned_at) formData.append('commissioned_at', form.commissioned_at);
      const res = await assetsAPI.create(formData);
      toast.success('Asset created');
      onCreated?.(res.data);
      onClose();
      setForm({ asset_name: '', installed_power_kw: '', installed_capacity_kwh: '', manufacturer: '', model: '', serial_number: '', vendor_asset_id: '', commissioned_at: '' });
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Failed to create asset');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-lg">
        <DialogHeader><DialogTitle>Create BESS Asset</DialogTitle></DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-3 mt-3">
          <div>
            <Label>Asset Name *</Label>
            <Input value={form.asset_name} onChange={e => setForm({ ...form, asset_name: e.target.value })} placeholder="e.g. PCS#1 250kW" className="mt-1" data-testid="asset-name-input" required />
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div>
              <Label>PCS Power (kW) *</Label>
              <Input type="number" step="any" value={form.installed_power_kw} onChange={e => setForm({ ...form, installed_power_kw: e.target.value })} className="mt-1" data-testid="asset-power-input" required />
            </div>
            <div>
              <Label>Battery (kWh) *</Label>
              <Input type="number" step="any" value={form.installed_capacity_kwh} onChange={e => setForm({ ...form, installed_capacity_kwh: e.target.value })} className="mt-1" data-testid="asset-capacity-input" required />
            </div>
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div>
              <Label>Manufacturer</Label>
              <Input value={form.manufacturer} onChange={e => setForm({ ...form, manufacturer: e.target.value })} className="mt-1" data-testid="asset-mfr-input" />
            </div>
            <div>
              <Label>Model</Label>
              <Input value={form.model} onChange={e => setForm({ ...form, model: e.target.value })} className="mt-1" data-testid="asset-model-input" />
            </div>
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div>
              <Label>Serial Number</Label>
              <Input value={form.serial_number} onChange={e => setForm({ ...form, serial_number: e.target.value })} className="mt-1" />
            </div>
            <div>
              <Label>Commissioned Date</Label>
              <Input type="date" value={form.commissioned_at} onChange={e => setForm({ ...form, commissioned_at: e.target.value })} className="mt-1" data-testid="asset-date-input" />
            </div>
          </div>
          <div className="flex justify-end space-x-3 pt-3 border-t">
            <Button type="button" variant="outline" onClick={onClose}>Cancel</Button>
            <Button type="submit" disabled={saving} className="bg-slate-900 hover:bg-slate-800" data-testid="create-asset-submit">
              {saving ? 'Creating...' : 'Create Asset'}
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
